// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"478":"22c0c837","498":"cd0e78eb","703":"1a954974"}[chunkId] + ".chunk.js";
};